import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { SemesterService } from '@app/_services/masters/semester.service';
import { semester } from '@app/_models/semester';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { LogService } from '../../../_shared/log.service'
import { VerifyDocumentService } from '@app/_services/verifyDocument.service';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-semester-master-add',
  templateUrl: './semester-master-add.component.html',
  styleUrls: ['./semester-master-add.component.css']
})
export class SemesterMasterAddComponent implements OnInit {

  constructor(private eventService: LogService, private formBuilder: FormBuilder, private semesterService: SemesterService,
    private modalService: NgbModal, config: NgbModalConfig,private verifyDocService: VerifyDocumentService,  private router: Router) { }

  semester = new semester();
  streamDropDown = [];
  streamId: number;
  semesterForm: FormGroup;
  submitted = false;
  strMessage: string;
  getresponse: any;
  returnUrl;

  @ViewChild('showModalBox', { read: TemplateRef }) showModalBoxTemplate: TemplateRef<any>;


  ngOnInit(): void {
    this.semesterForm = this.formBuilder.group({
      semesterName: ['', Validators.required],
      streamid: ['', Validators.required],
    });

    this.verifyDocService.getStreams()
    .pipe(first())
    .subscribe(
      data => {
        // console.log("streams response---", data.respData)
        this.streamDropDown = data.respData;
      },
      error => {
        console.log(error)
      }
    )
    
  }
  get f() { return this.semesterForm.controls; }

  addSemester() {
    this.submitted = true;

    if (this.semesterForm.invalid) {
      return;
    }
    this.semesterService.addSemester(this.semester)
      .subscribe((response) => {
        if (response) {
          this.getresponse = response;
          if (this.getresponse.respMessage == "Success") {
            this.strMessage = "Semester Added Successfully.";
            this.modalService.open(this.showModalBoxTemplate);
            var v = response;
          }

          else if (this.getresponse.respMessage == "Failure") {
            this.strMessage = this.getresponse.respData;
            this.modalService.open(this.showModalBoxTemplate);
            var v = response;
          }
        }
      },
        (err: any) => {
          var message = err;
        });
  }

  refresh(): void {
    this.modalService.dismissAll(this.showModalBoxTemplate);
    this.eventService.emit<string>('21');
  }

  goBack() {
    this.eventService.emit<string>('21');
  }





}
